import { render, staticRenderFns } from "./indexPlanos.vue?vue&type=template&id=94b9b9d2&scoped=true"
import script from "./indexPlanos.vue?vue&type=script&lang=js"
export * from "./indexPlanos.vue?vue&type=script&lang=js"
import style0 from "./indexPlanos.vue?vue&type=style&index=0&id=94b9b9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b9b9d2",
  null
  
)

export default component.exports